import ozMainLocations from './oz-main-locations.vue'

export default ozMainLocations
